<div class="row">
  <div class="col-12">
    <div class="row mb-3">
      <div class="col-12 col-md-6">
        <h1>Headlines:</h1>

        <code>&lt;h1&gt;Headline Level 1 (h1, .mat-h1, .mat-headline)&lt;/h1&gt;</code>
        <h1>Headline Level 1</h1>

        <code>&lt;h2&gt;Headline Level 1 (h2, .mat-h2, .mat-title)&lt;/h1&gt;</code>
        <h2>Headline Level 2</h2>

        <code>&lt;h3&gt;Headline Level 3 (h3, .mat-h3, .mat-subheading-2)&lt;/h1&gt;</code>
        <h3>Headline Level 3</h3>

        <code>&lt;h4&gt;Headline Level 4 (h4, .mat-h4, .mat-subheading-1)&lt;/h4&gt;</code>
        <h4>Headline Level 4</h4>

        <code>&lt;span class="mat-body"&gt;Base body text 1 (.mat-body, .mat-body-1)&lt;/span&gt;</code>
        <div class="mat-body">Base body text 1</div>

        <code>&lt;span class="mat-body-strong"&gt;Base body text 2 (.mat-body-strong, .mat-body-2)&lt;/span&gt;</code>
        <div class="mat-body-strong">Bolder body text 2</div>

        <code>&lt;span class="mat-small"&gt;Smaller body and hint text (.mat-small, .mat-caption)&lt;/span&gt;</code>
        <div class="mat-small">Smaller body and hint text</div>

        <mat-divider></mat-divider>

        <h1>Force headers</h1>

        <h1 class="sh-forced-h3">H1 Header with forced styles from H3</h1>
        <h2 class="sh-forced-h3">H2 Header with forced styles from H3</h2>
        <h3 class="sh-forced-h3">H3 Header with forced styles from H3</h3>
        <h4 class="sh-forced-h3">H4 Header with forced styles from H3</h4>
      </div>
      <div class="col-12 col-md-6">
        <h1>Captions:</h1>

        <code>&lt;h1&gt;Caption 4 (.mat-display-4)&lt;/h1&gt;</code>
        <div class="mat-display-4">Caption 4</div>

        <code>&lt;h1&gt;Caption 3 (.mat-display-3)&lt;/h1&gt;</code>
        <div class="mat-display-3">Caption 3</div>

        <code>&lt;h1&gt;Caption 2 (.mat-display-2)&lt;/h1&gt;</code>
        <div class="mat-display-2">Caption 2</div>

        <code>&lt;h1&gt;Caption 1 (.mat-display-1)&lt;/h1&gt;</code>
        <div class="mat-display-1">Caption 1</div>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <h1>Paragraph:</h1>
    <code>&lt;p&gt;... text ...&lt;/p&gt;</code>

    <div>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque ultrices ultrices lorem et commodo. Maecenas pretium lacinia lacus quis lobortis.</p>
      <p>
        Phasellus placerat dolor sapien, ac aliquam diam pretium in. Duis rhoncus congue ornare. Phasellus non nisl fringilla enim auctor fermentum vitae eget
        mauris.
      </p>
      <p>Sed finibus mi lacus, et malesuada mi blandit ut. Curabitur maximus sem ac placerat convallis.</p>
    </div>
  </div>

  <div class="col-12 col-md-6">
    <h1>Span:</h1>
    <code>&lt;span&gt;... text ...&lt;/span&gt;</code>

    <div>
      <span
        >Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque ultrices ultrices lorem et commodo. Maecenas pretium lacinia lacus quis
        lobortis.</span
      >
      <span
        >Phasellus placerat dolor sapien, ac aliquam diam pretium in. Duis rhoncus congue ornare. Phasellus non nisl fringilla enim auctor fermentum vitae eget
        mauris.</span
      >
      <span>Sed finibus mi lacus, et malesuada mi blandit ut. Curabitur maximus sem ac placerat convallis.</span>
    </div>
  </div>

  <div class="col-12">
    <a
      href="https://material.angular.io/guide/typography"
      target="_blank"
      >https://material.angular.io/guide/typography</a
    >
  </div>
</div>
